export default __webpack_public_path__ + "static/media/mixlr.dcd2cb7f.png";